export default (axios) => ({
  /**
   * Get cart
   *
   * @link https://devapi.omara.sk/apidoc/#api-Cart-GetApiV1Carts
   * @param payload
   * @param payload.cartId - Cart unique ID
   * @param payload.getCartByCartID - Get cart by cart ID flag
   * @param payload.userInfo - User information
   * @param payload.additionalParams - Additional query parameters to be included in the request
   * @returns {*}
   */
  getCart(payload) {
    const params = {};
    if (
      (payload?.cartId && payload.getCartByCartID) ||
      (payload?.cartId && !payload?.userInfo)
    ) {
      params.cart_unique_id = payload.cartId;
    }

    if (payload?.additionalParams) {
      Object.assign(params, payload.additionalParams);
    }

    return axios.get("/carts", { params });
  },
  /**
   * Create cart item
   *
   * @link https://devapi.omara.sk/apidoc/#api-Cart-PostApiV1CartsItems
   * @param payload
   * @returns {*}
   */
  setCartItem(payload) {
    return axios.post("/carts/items", payload);
  },

  /**
   * Add meta checkout
   *
   * @link https://devapi.omara.sk/apidoc/#api-Cart-PostApiV1CartsItems
   * @param data
   * @param data.products - Array of products with sku and quantity
   * @param data.coupon - Coupon code
   * @returns {*}
   */
  addMetaCheckout(data) {
    return axios.post("/carts/meta-checkout", data);
  },

  /**
   * Update cart item
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-Cart-PatchApiV1CartsItemsId
   * @param id
   * @param payload
   * @returns {*}
   */
  updateCartItem(id, payload) {
    return axios.patch(`/carts/items/${id}`, payload);
  },

  /**
   * Delete cart item
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-Cart-DeleteApiV1CartsItemsId
   * @param id
   * @param params
   * @returns {*}
   */
  deleteCartItem(id, params) {
    return axios.delete(`/carts/items/${id}`, { params });
  },

  /**
   * Bind gift card or discount to cart
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-Cart-PostApiV1CartsBindGiftCard
   * @param params
   * @returns {*}
   */
  bindDiscount(params) {
    return axios.post(`/carts/bind-gift-card`, params);
  },

  /**
   * Bind gift card or discount to cart
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-Cart-PostApiV1CartsUnbindGiftCard
   * @param params
   * @returns {*}
   */
  unbindDiscount(params) {
    return axios.post(`/carts/unbind-gift-card`, params);
  },

  /**
   * Storing checkout data
   *
   * @link https://devapi.omara.sk/public/apidoc/#api-Cart-PostApiV1CartsCheckout
   * @param params
   * @returns {*}
   */
  checkout(params) {
    return axios.post(`/carts/checkout`, params);
  },

  /**
   * Create Stripe Payment Session
   *
   * @link https://devapi.omara.sk/apidoc/#api-Cart-PostApiV1CartsCheckoutStripeSession
   * @param params
   * @returns {*}
   */
  createStripePaymentSession(payload) {
    return axios.post(`/carts/checkout/stripe/session`, payload);
  },

  /**
   * Get Checkout Stripe Session
   *
   * @param params
   * @returns {*}
   */
  getCheckoutStripeSession(params) {
    return axios.get("/carts/checkout/stripe/session", { params });
  },
  /**
   * Start checkout event
   *
   * @link
   * @returns {*}
   * @param cart_unique_id
   */
  sendStartCheckoutEvent(cart_unique_id) {
    return axios.patch(`/carts/${cart_unique_id}/start-checkout`);
  },

  /**
   * Update cart
   *
   * @link
   * @returns {*}
   * @param cart_unique_id
   * @param data
   */
  updateCart(cart_unique_id, data) {
    return axios.patch(`/carts/${cart_unique_id}`, data);
  },

  /**
   * Start express payment
   *
   * @returns {*}
   */
  startExpressPayment(payload) {
    return axios.post("/carts/checkout/express", payload);
  },

  finalizeCart({ cart_unique_id }) {
    if (!cart_unique_id) {
      return;
    }
    return axios.post(`/carts/checkout/finish-immediately`, {
      cart_unique_id,
    });
  },

  /**
   * Check Mollie Payment Status
   *
   * @param params
   * @returns {*}
   */
  checkMolliePayment(params) {
    return axios.get("/payment/check-mollie-payment", { params });
  },

  /**
   * Express mollie payment
   *
   * @api {post} /api/v1/payment/express-mollie-payment Express mollie payment
   * @param payload
   * @returns {*}
   */
  expressMolliePayment(payload) {
    return axios.post("/payment/express-mollie-payment", payload);
  },

  /**
   * Mollie Apple Pay session validation
   *
   * @api {post} /api/v1/payment/mollie-apple-pay-session Mollie Apple Pay session
   * @param payload
   * @returns {*}
   */
  mollieApplePaySession(payload) {
    return axios.post("/payment/mollie-apple-pay-session", payload);
  },
});
